<template>
  <div class="container">
    <div class="content">
      <div class="Breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: typeObj[type].url }">{{
            typeObj[type].text
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ newsDetails.noticeTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news-title">
        {{ newsDetails.noticeTitle }}
      </div>
      <div class="news-date">{{ handelDate(newsDetails.createTime) }}</div>
      <div class="news-content">
        <div v-html="strHtml"></div>
        <div class="last" v-if="false">
          <p>山东省租房建设山东省租房建设</p>
          <p>2024年5月12日</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNesDetails } from "@/api";
export default {
  name: "NewsDetails",

  data() {
    return {
      newsDetails: {},
      type: "",
      strHtml:'',
      typeObj: {
        1: { text: "建设要闻", url: "/news" },
        2: { text: "通知公告", url: "/notices" },
        3: { text: "政策法规", url: "/policy" },
        4: { text: "帮助中心", url: "/" },
      },
    };
  },

  mounted() {
    this.getDetails(this.$route.query.noticeId);
    this.type = this.$route.query.type;
  },
  methods: {
    handelDate(date) {
      return date && date.split(" ")[0];
    },
    getDetails(noticeId) {
      getNesDetails(noticeId).then((res) => {
        this.newsDetails = res.data;

        let arr = res.data.noticeContent.split('\"')
        arr[1] = `${process.env.VUE_APP_BASE_URL}`+arr[1]
        this.strHtml = arr.join('')
      });
    },

  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f4f8;
  padding-bottom: 92px;
}
.content {
  background: #fff;
  padding-top: 85px;

  .Breadcrumb {
    border-bottom: 1px solid #ddd;
    padding-bottom: 16px;
    margin-bottom: 95px;
    margin-left: 85px;
    margin-right: 20px;
  }
  .news-title {
    font-size: 26px;
    color: #000;
    text-align: center;
    margin-bottom: 40px;
  }
  .news-date {
    color: #939393;
    font-size: 16px;
    margin-bottom: 60px;
    text-align: center;
  }
  .news-content {
    font-size: 16px;
    color: #000;
    padding: 0 160px 130px;
    line-height: 30px;
    .last {
      padding-top: 80px;
      text-align: right;
      p:nth-child(1) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
